(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('eventsList', EventsListDirective)

    /** @ngInject */
    function EventsListDirective(PATHS) {
        function EventsListDirectiveController() {
            const vm = this;

            let isPreviousInformative = false;

            vm.getEventLink = event => {
                let eventUrl = '';

                if (isPreviousInformative)
                    eventUrl = `/events/${event.Url}?NewsId=${vm.newsId}&NewsTitle=${vm.newsTitle}`
                else
                    eventUrl = `/events/${event.Url}`;

                return eventUrl;
            }

            vm.init = () => {
                if (vm.newsId && vm.newsTitle)
                    isPreviousInformative = true;
            }
        }

        function link(scope, attrs, elem, ctrl) {
            ctrl.init();
        }

        return {
            bindToController: true,
            controller: EventsListDirectiveController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/events-list/events-list.html`,
            link: link,
            scope: {
                events: '=',
                newsId: '=',
                newsTitle: '='
            }
        }
    }
}());